import { toggleModal, toggleCustomModal } from './modal';
import { toggleModal as toggleSessionModal } from '../sessions/lib';
// import API from "@/lib/api";
import PointManager from '../point/manager';

onload(() => {
  const pointManager = new PointManager;

  // 시작하기(모달 팝업) Jquery버전 한번 써봄
  $('.show-modal').each((i, e) => {
    $(e).on('click', evt => {
      toggleModal($(e).data('index'), true);
    });
  });

  // 로그인하기
  $('.show-session-modal').each((i, e) => {
    $(e).on('click', evt => {
      toggleSessionModal(true);
    });
  });

  // 테마 구매하기
  $('.show-purchase-modal').each((i, e) => {
    $(e).on('click', evt => {
      const themeId = $(e).data('theme-id');
      const price = $(e).data('price');

      pointManager.default({
        themeId: themeId,
        price: price,
        callback: () => {
          toggleModal($(e).data('index'), true);
        }
      });
    });
  });

  // 포인트 충전하기
  $('.show-charge-modal').each ((i, e) => {
    $(e).on('click', evt => {
      const themeId = $(e).data('theme-id');
      const price = $(e).data('price');

      pointManager.default({
        themeId: themeId,
        price: price,
        callback: () => {
          toggleModal($(e).data('index'), true);
        }
      });
    });
  });

  // 메시지 표시
  $('.show-message').each((i, e) => {
    $(e).on('click', evt => {
      Swal.fire({
        title: e.dataset.title,
        text: e.dataset.message,
        confirmButtonText: '확인'
      });
    });
  });

  // 새로 하기
  $('.new-game').each((i, e) => {
    $(e).on('click', evt => {
      Swal.fire({
        title: '기존 플레이 기록은 초기화됩니다.',
        text: "새로하기를 진행하시겠습니까?",
        showCancelButton: true,
        // showDenyButton: true,
        confirmButtonText: '진행',
        cancelButtonText: '취소',
        // denyButtonText: '취소'
      }).then((result) => {
        if (result.isConfirmed) toggleModal($(e).data('index'), true);
      });
    });
  });

  // 이어 하기
  $('.continue-play').each((i, e) => {
    $(e).on('click', evt => {
      redirectTo($(e).data('url'));
    });
  });

  // 테마 재입장 FAKE END
  $('.fake-end').each((i, e) => {
    $(e).on('click', evt => {
      Swal.fire({
        title: '이미 플레이를 마친 테마입니다.',
        text: "그래도 재입장하시겠습니까?",
        // showCancelButton: true,
        // showDenyButton: true,
        confirmButtonText: '테마 재입장',
        // cancelButtonText: '취소',
        // denyButtonText: '취소'
      }).then((result) => {
        if (result.isConfirmed) redirectTo($(e).data('url'));
      });
    });
  });

  // 이어 하기?
  // const continueButton = document.querySelector('#continue-play');
  // continueButton?.addEventListener('click', e => {
  //   const url = `/plays/start/${continueButton.dataset.id}`;
  //   redirectTo(url);
  // });

  // K-League
  $('.show-custom-modal').each((i, e) => {
    $(e).on('click', evt => {
      toggleCustomModal($(e).data('modal-id'), true);
    });
  });
})